import { useEffect, useState } from "react";
import ContentWrapper from "../../views/components/ContentWrapper";
import { getFeedback } from "../../data/dataApi";
import Pagination from "../../views/components/Pagination";
import { ReactComponent as ThumbUpOn } from "../../images/thumb-up-on.svg";
import { ReactComponent as ThumbUpOff } from "../../images/thumb-up-off.svg";
import { ReactComponent as ThumbDownOn } from "../../images/thumb-down-on.svg";
import { ReactComponent as ThumbDownOff } from "../../images/thumb-down-off.svg";
import DataSubMenu from "../../views/components/DataSubMenu";
import { useParams, useNavigate } from "react-router";

const Feedback = () => {
    const { page, rating } = useParams();

    let ratingFilter;
    
    if(rating) {
        if(rating === "up") {
            ratingFilter = "Thumb Up";
        } else if(rating === "down") {
            ratingFilter = "Thumb Down";
        } else {
            ratingFilter = "All";
        }
    }

    const [feedback, setFeedback] = useState([]);
    const [activeTab, setActiveTab] = useState(ratingFilter || "All");

    const navigate = useNavigate();

    const listLimit = 30;

    const subNavOptions = ["All", "Thumb Up", "Thumb Down"];

    useEffect(() => {
        (async () => {
            const response = await getFeedback(page === undefined ? 0 : page - 1, rating || "");

            if(response.success) {
                setFeedback(response.data.rows);
            }
        })();
    }, [page, rating]);

    useEffect(() => {
        if(activeTab !== "All") {
            let ratingPath = "";

            if(activeTab === "Thumb Up") {
                ratingPath = "up";
            } else if(activeTab === "Thumb Down") {
                ratingPath = "down";
            }

            navigate(`/feedback/page/1${ ratingPath ? `/${ ratingPath }` : '' }`);
        } else {
            navigate("/feedback");
        }
    }, [activeTab]);

    return(
        <ContentWrapper className="scrollable">
            <DataSubMenu subNavOptions={ subNavOptions } activeTab={ activeTab } setActiveTab={ setActiveTab } />
            <div className="wrapper">
                <div className="table-wrapper">
                    <table className="primary-table">
                        <thead>
                            <tr>
                                <td>ID</td>
                                <td>User IP</td>
                                <td>Country</td>
                                <td>Time</td>
                                <td>Rating</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                feedback.map((entry) =>
                                    <tr key={ entry.id } onClick={() => navigate(`/feedback/${ entry.id }`)}>
                                        <td>{ entry.id }</td>
                                        <td>{ entry.user_ip }</td>
                                        <td>{ entry.country }</td>
                                        <td>{ entry.time }</td>
                                        <td>
                                            {
                                                entry.rating === "up" ?
                                                    <>
                                                        <ThumbUpOn className="thumb-up-on tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOff className="thumb-down-off tif-ml-md-10 tif-ml-5" />
                                                    </>
                                                :
                                                    <>
                                                        <ThumbUpOff className="thumb-up-off tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOn className="thumb-down-on tif-ml-md-10 tif-ml-5" />
                                                    </>
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>

                    <Pagination listLength={ feedback.length && feedback[0].total_count } page={ page } path="/feedback" filter={ rating } limit={ listLimit } />
                </div>
            </div>
        </ContentWrapper>
    );
};

export default Feedback;